<template>
  <div class="container">
    <div class="row mb-5 justify-content-md-center">
      <div class="col mt-4 mb-4 card-accont col-lg-8">
        <div class="row mb-2">
          <div class="col-lg-12 text-center card-accont-title">Seguridad</div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label>Contraseña: XXXXXXXXX</label>
          </div>
          <div class="col-lg-6 text-right">
            <span v-if="!show_form" class="btn-purple" v-on:click="showForm">CAMBIAR</span>
            <span v-else class="btn-orange" v-on:click="showForm">CANCELAR</span>
          </div>
        </div>
        <div class="row mt-2" v-show="show_form">
          <div class="col-lg-12">
            <hr />
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="exampleInputPassword1">Nueva Contraseña</label>
              <password
                v-model="updatePasswordCredentials.newPassword"
                :strength-meter-only="false"
                :toggle="true"
                :default-class="'form-control'"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="exampleInputPassword1">Confirmar nueva contraseña</label>
              <password
                v-model="updatePasswordCredentials.confirmNewPassword"
                :strength-meter-only="false"
                :toggle="true"
                :default-class="'form-control'"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <div
              class="alert alert-danger"
              role="alert"
              v-if="showPasswordDoNotMatch"
            >Las contraseñas no coinciden</div>
            <div class="col-lg-12 text-center mt-4" v-on:click="updatePassword">
              <span class="btn-purple">CAMBIAR</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Password from 'vue-password-strength-meter'

export default {
  components: {
    Password
  },
  data () {
    return {
      show_form: false,
      showPasswordDoNotMatch: false,
      updatePasswordCredentials: {
        newPassword: '',
        confirmNewPassword: '',
        changeNewPassword: true
      }
    }
  },
  watch: {
    updatePasswordCredentials: {
      deep: true,
      handler () {
        this.comparePasswords()
      }
    }
  },
  methods: {
    ...mapActions({
      updatePasswordOnSignIn: 'updatePasswordOnSignIn'
    }),
    showForm () {
      if (!this.show_form) {
        this.show_form = true
      } else {
        this.show_form = false
      }
    },
    comparePasswords () {
      if (this.updatePasswordCredentials.newPassword === this.updatePasswordCredentials.confirmNewPassword) {
        this.showPasswordDoNotMatch = false
      } else {
        this.showPasswordDoNotMatch = true
      }
    },
    async updatePassword () {
      try {
        const emptyNewPassword = this.$_.isEmpty(this.updatePasswordCredentials.newPassword)
        const emptyConfirmPassword = this.$_.isEmpty(this.updatePasswordCredentials.confirmNewPassword)
        if (emptyNewPassword || emptyConfirmPassword) {
          this.isLoading = false
          this.showError('Debes llenar todos los campos.')
          return
        }
        if (this.updatePasswordCredentials.newPassword === this.updatePasswordCredentials.confirmNewPassword) {
          this.showPasswordDoNotMatch = false
        } else {
          this.showPasswordDoNotMatch = true
          return
        }
        const response = await this.updatePasswordOnSignIn(this.updatePasswordCredentials)
        if (response.updated) {
          this.show_form = false
          this.$toastedPush({
            message: 'Tu contraseña fue cambiada.',
            type: 'success'
          })
        }
      } catch (error) {
        this.isLoading = false
        this.showError(error.message)
      }
    }
  }
}
</script>
